import * as Yup from "yup";

const impressaoEtiquetaValidator = Yup.array().of(
  Yup.object().shape({
    produtoId: Yup.number().when("checked", (checked) => {
      return checked
        ? Yup.number().required("Produto")
        : Yup.number().nullable();
    }),
    quantidade: Yup.number().when("checked", (checked) => {
      return checked
        ? Yup.number().required("Quantidade")
        : Yup.number().nullable();
    }),
  })
).min(1, "No mínimo, um produto");

export default impressaoEtiquetaValidator;
